const routes = [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('./views/Profile/index.vue'),
    meta: {
      title: 'Настройки пользователя',
    },
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('./views/AllUsers.vue'),
    meta: {
      title: 'Пользователи',
    },
  },
  {
    path: '/users/:id',
    name: 'users-id',
    component: () => import('./views/User.vue'),
  },
];

export default routes;
